import React from 'react';



type Props = {
  className?: string;
}
export const FilterVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M6 10C7.65685 10 9 8.65685 9 7C9 5.34315 7.65685 4 6 4C4.34315 4 3 5.34315 3 7C3 8.65685 4.34315 10 6 10Z' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M18 20C19.6569 20 21 18.6569 21 17C21 15.3431 19.6569 14 18 14C16.3431 14 15 15.3431 15 17C15 18.6569 16.3431 20 18 20Z' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M13 7H21' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M3 17H11' />
    </svg>
  );
};
